import React, { useEffect } from 'react';
import './signup.css';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withAuth0 } from '@auth0/auth0-react';
import { loadOrganizationData } from '../../../utils/loadOrganizationData';
import { persistor } from '../../..';
import { cbContinueSignUp } from '../../../TuqqiRouting';
import Spinner from '../../components/Common/spinner/spinner';

const sleep = ms => new Promise(r => setTimeout(r, ms));

export const STEP_ONE = "step1";
export const STEP_TWO = "step2";
export const STEP_THREE = "step3";
export const STEP_FOUR = "step4";
export const STEP_FIVE = "step5";


const SignupPage = (props) => {
    const { services, auth0, dispatch, userSettingsService } = props;
    

    useEffect(() => {
        const fetchData = async (claims) => {

            const idToken = await auth0.getIdTokenClaims();

            services.userSettingsService.acceptInvitation().then(async () => {
                const userrr = await userSettingsService.getUser();

                await loadOrganizationData(idToken.__raw, dispatch)
                await sleep(500)
                await persistor.persist()
                await sleep(200)
                cbContinueSignUp.value(userrr)
            })
        };

        fetchData();
    }, []);


    return <Spinner />
};


const mapStateToProps = (state, ownProps) => ({
    userData: state.userData,
    authService: state.authModule.authService,
    userSettingsService: state.services.userSettingsService,
    services: state.services
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch
    }
}

export default compose(
    withAuth0,
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(SignupPage);



// export default SignupPage;